<!-- Confirmation Component -->
<div class="main row">
  <ds-confirmation [confirmationData]="confirmationData$ | async">
    <ds-confirmation-link-area>
      <button ds-button class="-outline margin-right-10" (click)="routeToPolicies()">
        View Your Policy
      </button>
      @if ((advancedAutoRisks$ | async)?.length > 1) {
        <button ds-button class="-outline-white" (click)="routeToRiskSelection()">
          Change Another Policy
        </button>
      }
    </ds-confirmation-link-area>
  </ds-confirmation>
</div>

<!-- Header Cell required for stacking tables (Requires name, shortName optional) -->
<ng-template #headerCellTpl let-column="column">
  <div class="header-cell table-header-cell-wrapper">
    <span
      [ngClass]="{
        'none lg-block': column?.name && column?.shortName,
        block: column?.name && !column?.shortName
      }"
      >{{ column?.name }}</span
    >
    @if (!!column?.shortName) {
      <span class="block lg-none">{{ column?.shortName }}</span>
    }
  </div>
</ng-template>

<!-- Vehicle cell template -->
<ng-template #vehicleCellTpl let-row="row">
  @if (!!row) {
    <div class="acct-cell ds-table-body-cell-header-wrapper">
      <div class="block md-none ds-table-body-cell-header">
        <span class="overflow-hidden overflow-ellipsis">
          <p>{{ row.vehicleName | async }}</p>
        </span>
      </div>
      <div class="none md-block table-body-cell-label-content expandable-cell bordered-cell-first">
        <span class="overflow-hidden overflow-ellipsis">
          <p>{{ row.vehicleName | async }}</p>
        </span>
      </div>
    </div>
  }
</ng-template>

<!-- New Deductible Template -->
<ng-template #newDeductibleCellTpl let-row="row">
  @if (!!row) {
    <div class="acct-cell ds-table-body-cell-header-wrapper">
      <div class="block md-none ds-table-body-cell-header">
        <span class="overflow-hidden overflow-ellipsis">
          @if (row.newDeductibles.comprehensive | async) {
            <p>Comprehensive Coverage: ${{ row.newDeductibles.comprehensive | async }}</p>
          }
          @if (row.newDeductibles.collision | async) {
            <p>Collision Coverage: ${{ row.newDeductibles.collision | async }}</p>
          }
        </span>
      </div>
      <div class="none md-block table-body-cell-label-content expandable-cell bordered-cell-first">
        <span class="overflow-hidden overflow-ellipsis">
          @if (row.newDeductibles.comprehensive | async) {
            <p>Comprehensive Coverage: ${{ row.newDeductibles.comprehensive | async }}</p>
          }
          @if (row.newDeductibles.collision | async) {
            <p>Collision Coverage: ${{ row.newDeductibles.collision | async }}</p>
          }
        </span>
      </div>
    </div>
  }
</ng-template>

<!-- Add ons template -->
<ng-template #addonsCellTpl let-row="row">
  @if (!!row) {
    <div class="acct-cell ds-table-body-cell-header-wrapper">
      <div class="block md-none ds-table-body-cell-header">
        <span class="overflow-hidden overflow-ellipsis">
          @if (!!(row.addons.rental | async)) {
            <p>Rental Reimbursement: {{ row.addons.rental | async | formatRentalDeductibles }}</p>
          }
          @if (!!(row.addons.era | async)) {
            <p>Emergency Roadside Assistance</p>
          }
        </span>
      </div>
      <div class="none md-block table-body-cell-label-content expandable-cell bordered-cell-first">
        <span class="overflow-hidden overflow-ellipsis">
          @if (!!(row.addons.rental | async)) {
            <p>Rental Reimbursement: {{ row.addons.rental | async | formatRentalDeductibles }}</p>
          }
          @if (!!(row.addons.era | async)) {
            <p>Emergency Roadside Assistance</p>
          }
        </span>
      </div>
    </div>
  }
</ng-template>
